export const option = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: true,
  searchMenuSpan: 6,
  searchLabelWidth: 100,
  labelWidth: 150,
  border: true,
  index: true,
  menu: false,
  indexLabel: '序号',
  selection: false,
  viewBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  column: [
    {
      label: '租赁人',
      prop: 'name',
      display: false,
      search: true,
    },
    {
      label: '车牌号',
      prop: 'carFirstNumber',
      display: false,
      search: true,
    },
    {
      label: 'id',
      prop: 'id',
      display: false,
      hide: true,
    },
    {
      label: '状态',
      prop: 'recordType',
      span: 24,
      display: false,
      search: true,
      type: "select",
      dicData: [
        {
          label: '入库',
          value: 1,
        },
        {
          label: '出库',
          value: 2,
        },
      ],
    },
    {
      label: '类型',
      prop: 'recordStatus',
      span: 24,
      display: false,
      search: true,
      type: "select",
      dicData: [
        {
          label: '邮寄',
          value: 1,
        },
        {
          label: '归还',
          value: 2,
        },
        {
          label: '借出',
          value: 3,
        },
        {
          label: '结清',
          value: 4,
        },
        {
          label: '换库',
          value: 5,
        },
        {
          label: '修改数量',
          value: 6,
        },
      ],
    },
  ],
};
